import {
  createUnifiedTheme,
  createBaseThemeOptions,
  palettes,
} from '@backstage/theme';

// Brand palette pulled from raithu.tech
const forest = '#0D2B30';
const forestDeep = '#07201E';
const green = '#0E7C66';
const greenBright = '#1BB18A';
const spring = '#56D4AC';
const honey = '#E89B30';
const bg = '#F1EFE8';
const bgSoft = '#F8F6EF';
const ink = '#15262B';
const inkSoft = '#586A6A';
const onDark = '#EAF3EF';

export const raithuLightTheme = createUnifiedTheme(
  createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: { main: green },
      secondary: { main: honey },
      background: { default: bg, paper: bgSoft },
      text: { primary: ink, secondary: inkSoft },
      navigation: {
        background: forestDeep,
        indicator: greenBright,
        color: onDark,
        selectedColor: '#FFFFFF',
        navItem: { hoverBackground: forest },
        submenu: { background: forest },
      },
      link: green,
      linkHover: greenBright,
    },
  }),
);

export const raithuDarkTheme = createUnifiedTheme(
  createBaseThemeOptions({
    palette: {
      ...palettes.dark,
      primary: { main: greenBright },
      secondary: { main: honey },
      background: { default: forestDeep, paper: forest },
      navigation: {
        background: forestDeep,
        indicator: greenBright,
        color: onDark,
        selectedColor: '#FFFFFF',
        navItem: { hoverBackground: forest },
        submenu: { background: forest },
      },
      link: spring,
      linkHover: greenBright,
    },
  }),
);
